import { useContext } from 'react'
import { SelectContext } from '../SelectContext'

/** @deprecated */
export function useSelectContext() {
  return useContext(SelectContext)
}
